<script>
import Message from '@/components/dump/Message.vue'
import ConstructionScheme from '@/components/dump/ConstructionScheme.vue'

export default {
  name: 'AdditionalParams',
  components: { ConstructionScheme, Message },
  props: {
    sector: {
      type: Object,
      default: () => {}
    }
  },
  computed: {
    hasAdditionalFloorParams() {
      return this.sector.constructionType.isCombinedLocation
    },
    viewTechnicalRoomsMessage() {
      return this.sector.constructionType.isCombinedLocation &&
        this.sector.constructionType.location?.title.includes(this.$t('message.constructionTypes.message.markedOption'))
    }
  }
}
</script>

<template>
  <section class="additional-params">
    <Message
      :withToggle="true"
      id="additionalFloorToggler"
      :initialToggleState="hasAdditionalFloorParams"
      :text="$t('message.constructionTypes.message.addFloorParams')"
      @handle="$emit('update', $event)"/>
    <ConstructionScheme
      :url="''"
      :canShow="true"
      :canZoom="false"
      :classList="{
        'add-floor-params-scheme': true,
        'add-floor-params-scheme--checked': hasAdditionalFloorParams
      }"
    >
      <img src="@/assets/img/add-floor-params.svg" width="100%" alt="" />
    </ConstructionScheme>
    <slot v-if="hasAdditionalFloorParams"></slot>
    <Message
      v-if="viewTechnicalRoomsMessage"
      id="technicalRoomsMessage"
      :withToggle="false"
      :text="$t('message.constructionTypes.message.technicalRooms')" />
  </section>
</template>

<style lang="sass">
.additional-params
  display: grid
  grid-template-columns: repeat(4, 1fr)
  +media((grid-template-columns: (0: none, 700: repeat(3, 1fr), 768: repeat(4, 1fr))))
  +media((grid-template-areas: (0: 'message message' 'floor floor', 700: 'message message floor' 'message message floor', 768: 'message message message floor' 'message message message floor')))
  position: relative
  grid-gap: 0 rem(20)
  margin: rem(30) 0 0
  .message__article
    grid-area: message
  .add-floor-params-scheme
    grid-area: floor
    +media((display: (0: none, 700: flex)))
    margin: 0
    filter: grayscale(100%)
    opacity: 0.4
    &--checked
      opacity: 1
      filter: none
    .img-wrapper
      +media((height: (0: 100%, 768: rem(132), 1170: auto)))
      margin: 0
      border: none
      border-radius: 0
      img
        object-fit: fill
  &:has(.dropdown)
    +media((grid-template-areas: (0: 'message message' 'buildingType buildingType' 'location location' 'info info', 700: 'message message floor' 'buildingType buildingType buildingType' 'location location location' 'info info info', 768: 'message message message floor' 'buildingType buildingType buildingType buildingType' 'location location location location' 'info info info info')))
    .message__article, .add-floor-params-scheme
      margin-bottom: rem(30)
    .dropdown + .message__article
      grid-area: info
      margin: rem(30) 0 0
      background: $selection-color
</style>
